module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMyAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDFMMSAxMiIgc3Ryb2tlPSIjOUE5QTlBIiBzdHJva2Utd2lkdGg9IjEuOCIvPgo8cGF0aCBkPSJNMSAxTDEyIDEyIiBzdHJva2U9IiM5QTlBOUEiIHN0cm9rZS13aWR0aD0iMS44Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/RF_assets/icons/close-gray.svg
// module id = h+A0
// module chunks = 28